import SectionHeading from './SectionHeading'
import DataCard from './DataCard'
import './CardSection.css'

const CardSection = ({ id, title, icon, subtitle, data, fields, links }) => (
  <section className="card-section" id={id}>
    <SectionHeading icon={icon}>{title}</SectionHeading>
    {subtitle && <SectionHeading sub>{subtitle}</SectionHeading>}
    <div className="card-section__content">
      {data.map((item, i) => (
        <DataCard
          key={i}
          fields={fields.map(fn => item[fn])}
          links={links?.map(ln => ({ label: item[ln.label] || ln.label, url: item[ln.url] || ln.url }))}
        />
      ))}
    </div>
  </section>
)

export default CardSection
